import { TabStyles } from '@tableau/widgets';

// Tableau styles

const { Typography, Colors, Spacing } = TabStyles;

export const defaultFontFamily = 'inherit';
export const defaultFontSize = Typography.Sizing.Default;
export const tinyFontSize = Typography.Sizing.Tiny;
export const primaryFontColor = Typography.Color.Primary;
export const secondaryFontColor = Typography.Color.Secondary;

export const discreteDarkColor = Colors.DiscreteDark;

export const defaultSpace = Spacing.DefaultSpace;
export const largeSpace = Spacing.LargeSpace;
export const mediumSpace = Spacing.MediumSpace;

// Tooltip styles

export const tooltipSize = 300;

export const tooltipStyle: React.CSSProperties = {
  fontFamily: defaultFontFamily,
  fontSize: defaultFontSize
};

// Icon styles

export const certificationIconHeight = 19;

// Total width of certification icon including padding within the image.
export const certificationIconWidth = 24;

// For some reason we use the height for both dimensions.
export const certificationIconSize = certificationIconHeight;
